import Lenis from 'lenis';

export const lenis = () => {
  return new Lenis({
    autoToggle: false,
    lerp: 1,
    duration: .7,
    smoothWheel: true,
    autoRaf: true,
    easing: t => Math.sin((t * Math.PI) / 2)
  });
}
